module.exports = __webpack_public_path__ + "static/media/gamers_world.a6d2440e.png";